import { Pipe, PipeTransform } from '@angular/core';
import { ProductStockViewModel } from '@models/api-search.models';
import { StoreViewModel } from '@models/api.models';
import { checkStoreStock } from '@features/store-stock/helper/check-store-stock';

@Pipe({
    name: 'storeStock',
    standalone: true
})
export class StoreStock implements PipeTransform {
    transform(storeStocks: ProductStockViewModel[] | undefined, selectedStore: StoreViewModel): number {
        return checkStoreStock(storeStocks, selectedStore);
    }
}
